import BaseModel from '../base/BaseModel.model';
export default class PublicationDocument extends BaseModel {
    public contentTypeId?: number;
    public documentId?: number;
    public publicationUserId?: number;
    public document: any;
    constructor(){
        super();

        this.init();
    }

    init(){ 
        this.documentId = undefined;
        this.publicationUserId =undefined;  
    }
}